import React, { FC } from "react";
import SlidingIconButton from "./SlidingIconButton";
import { useStore } from "../../store/store";

const InfoButton: FC = () => {
    const { isInfoOpen, setInfoOpen, isTourOpen } = useStore();
  const onClick = () => {
    setInfoOpen(true);
  };
  return (
    <SlidingIconButton
      color="text-white"
      text="Informatie"
      iconClass="d-hint-i"
      className="hover:w-[7.5rem] hover:border-sunshineYellow"
      onClick={onClick}
      openByDefault={false}
      reverse={true}
      disabled={isTourOpen || isInfoOpen}
    />
  );
};

export default InfoButton;
